module.exports = __webpack_public_path__ + "static/media/morcare-logo.f6283d15.png";